import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Label } from 'semantic-ui-react'
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font, PDFDownloadLink, Svg } from '@react-pdf/renderer';
import axios from 'axios';
import './style.css';
import {
  Card,
  Table,
  Button,
  Checkbox,
  Stack,
  Paper,
  Avatar,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  FormControl,
  TextField
} from '@mui/material';
import Scrollbar from '../../components/scrollbar';
import { Link } from 'react-router-dom';
import SelectHuntingClub, { components } from 'react-select';
import SelectVrstaClanstva from 'react-select';

export default function Create(props) {
	
	const navigate  = useNavigate();
	
	const [huntingclubid, setHuntingClubId] = useState('');
	const [maticnibrojlovca, setMaticniBrojLovca] = useState('');	
	const [ime, setIme] = useState('');
	const [prezime, setPrezime] = useState('');
	const [datumrodjenja, setDatumRodjenja] = useState('');
	const [adresa, setAdresa] = useState('');
	const [telefon, setTelefon] = useState('');
	
	const [selectedOption, setSelectedOption] = useState(null);
	const [huntingclubs, setHuntingClubs] = useState(null);
	
	const [selectedoptionvrstaclanstva, setSelectedOptionVrstaClanstva] = useState('Aktivni');
	const [vrstaclanstva, setVrstaClanstva] = useState('Aktivni');
	
	const [huntingclubsdataloaded, setHuntingClubsDataLoaded] = useState(null);
	const [selecthuntingclubsdataloaded, setSelectHuntingClubsDataLoaded] = useState(null);
	const [awardtypeId, setAwardTypeId] = useState('1');
	const [options, setOptions] = useState('');
	
	const [checkedlovackilist, setCheckedLovaciList] = useState(true);
	const [checkedclanskupstine, setCheckedClanSkupstine] = useState(false);
	const [checkedgrupovodja, setCheckedGrupovodja] = useState(false);
	
	const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;
	
	
	useEffect(() => {
		if (!huntingclubsdataloaded) {
			getHuntingClubsAll();
		}
		
		if (huntingclubsdataloaded && !selecthuntingclubsdataloaded) {
			FillSelectHuntingClubsAll();
		}
		
		
	});
	
	const getHuntingClubsAll = async () => {
      try {
		const response = await axios.get(SERVER_URL + "/huntingclubs/");
        setHuntingClubs(response.data);
		setHuntingClubsDataLoaded(true);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
	};
	
	const FillSelectHuntingClubsAll = async () => {
      try {
		setSelectHuntingClubsDataLoaded(true);
		const clubs = [];
		huntingclubs.map((huntingclub, index) => ( clubs.push({ value: huntingclub.id, label: huntingclub.naziv, icon: huntingclub.flag })));
		console.log(clubs);
		setOptions(clubs);
      } catch (err) {
        console.log("error");
      }
	};

    const handleChangeHuntingClub = e => {
    	setSelectedOption(e);
		console.log(e);
		setHuntingClubId(e.value);
  	}	

    const handleChangeVrstaClanstva = e => {
    	setSelectedOptionVrstaClanstva(e);
		console.log(e);
		setVrstaClanstva(e.value);
  	}

	const handleChangeCheckLovackiList = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCheckedLovaciList(event.target.checked);
	};
	
	const handleChangeCheckClanSkupstine = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCheckedClanSkupstine(event.target.checked);
	};
	
	const handleChangeCheckGrupovodja = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCheckedGrupovodja(event.target.checked);
	};
	
	const optionsvrstaclanstva = [
		{ value: "Aktivni", label: "Aktivni", icon: ""},
		{ value: "Pionir", label: "Pionir", icon: ""},
		{ value: "Počasni", label: "Počasni", icon: ""},
	];
		
	const postData = () => {	
	  console.log(huntingclubid);
	  console.log(maticnibrojlovca);
	  console.log(ime);
	  console.log(prezime);
	  console.log(adresa);
	  console.log(telefon);
	  console.log(vrstaclanstva);
	
	
		axios.post(SERVER_URL + "/hunters",
			{
				"huntingclubId": huntingclubid,
				"maticnibrojlovca": maticnibrojlovca,
				"ime": ime,
				"prezime": prezime,
				"datumrodjenja": datumrodjenja,
				"adresa": adresa,
				"telefon": telefon,
				"vrstaclanstva": vrstaclanstva,
			    "clanskupstine": checkedclanskupstine,
			    "grupovodja": checkedgrupovodja,
				"lovackilist": checkedlovackilist
			}
			).then(() => {
				props.handler();
            // navigate('/dashboard/app')
        })
	}
	
  const styles = StyleSheet.create({
  page: {
    fontFamily: "Roboto"
  },
  body: {
    paddingTop: 50,
    paddingBottom: 65,
    paddingHorizontal: 30,
	fontFamily: "Roboto", 
	fontSize: 10,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Roboto'
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: 'Roboto'
  },
  text: {
    margin: 5,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmedium: {
    margin: 3,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmediumlarge: {
    margin: 12,
    fontSize: 20,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  textbig: {
    margin: 12,
    fontSize: 28,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  selectimage: {
    margin: 0,
	paddingTop : 0,
	padding : 0,
	height: 40,
	paddingHorizontal: 10,
  },
  selecttext: {
    margin: 3,
    fontSize: 16,
    textAlign: 'justify',
	paddingHorizontal: 20,
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  officer: {
	paddingTop: 70,
    fontSize: 12,
	margin: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
	left: 150,
  },
  officertext: {
    margin: 0,
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Roboto',
  },
  mp: {
    position: 'absolute',
    fontSize: 12,
    bottom: 100,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey'
  },
  table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid",  
    borderRightWidth: 0, 
	borderLefttWidth: 0, 
    borderTopWidth: 0,
	borderBottomWidth: 0,
  }, 
  tableRow: { 
    margin: "0", 
    flexDirection: "row",
	 borderWidth: 0,
  }, 
  tableCol: { 
    width: "20%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  }, 
  tableColLong: { 
    width: "5%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColShort: { 
    width: "15%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColVeryShort: { 
    width: "5%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableCell: { 
    width: "10%", 
    margin: "auto", 
    marginTop: 5, 
    fontSize: 10 
  },
  });
	
  const customStyles = {
  control: base => ({
    ...base,
	width: 300,
    height: 45,
    minHeight: 25,
	fontSize: 16,
  })
};
  
  const { Option } = components;
  const IconOption = props => (
	<Option {...props}>
	<TableRow style={styles.selectimage}>
	
	<TableCell style={styles.selectimage} align="left">
	
	    <Stack direction="row" alignItems="center" spacing={2}>
		
            <Avatar alt={props.data.label} src={props.data.icon} />
							
			<Typography style={styles.textmedium} variant="subtitle2" noWrap>
				
			</Typography>
			
        </Stack>
						  
	</TableCell>
	
	<TableCell style={styles.selectimage} align="left">
	<Typography style={styles.selecttext} variant="subtitle2" noWrap>
	{props.data.label}
	</Typography>
	</TableCell>
							
	</TableRow>
	</Option>
  );
  
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
		
    return (
		<Container maxWidth="xl">
	    <Typography variant="subtitle2" noWrap>
			Novi član
		</Typography>
        <Card>
		  
		    <TableContainer sx={{ minWidth: 1000 }}>
			
              <Table>
			  
                <TableBody>
        
                <TableRow>
					<TableCell component="th" scope="row" >
					<FormControl>
						<Label>Lovačko društvo</Label>
							<SelectHuntingClub 
							menuPortalTarget={document.body} 
							menuPosition={'fixed'}
							defaultValue={options[0]}
							options={options}
							components={{ Option: IconOption }}
							onChange={handleChangeHuntingClub}
							styles={customStyles}
						    />
					</FormControl>
					</TableCell>
					
                    <TableCell component="th" scope="row" >
						<Label>Matični broj</Label>
							<TextField
							required
							defaultValue=""
							onChange={(e) => setMaticniBrojLovca(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "80px",
							},
							}}
							/>
                    </TableCell>
					
					<TableCell component="th" scope="row" >
						<Label>Ime</Label>
							<TextField
							required
							defaultValue=""
							onChange={(e) => setIme(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>

                    <TableCell component="th" scope="row" >
						<Label>Prezime</Label>
							<TextField
							required
							defaultValue=""
							onChange={(e) => setPrezime(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>
					
					<TableCell component="th" scope="row" >
						<Label>Datum rođenja</Label>
							<TextField
							required
							defaultValue=""
							onChange={(e) => setDatumRodjenja(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							},
							}}
							/>
                    </TableCell>
						
                </TableRow>
				
				<TableRow>
                    <TableCell component="th" scope="row" >
						<Label>Adresa</Label>
							<TextField
							required
							defaultValue=""
							onChange={(e) => setAdresa(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "270px",
							},
							}}
							/>
                    </TableCell>
					
                    <TableCell component="th" scope="row" >
						<Label>Telefon</Label>
							<TextField
							required
							defaultValue=""
							onChange={(e) => setTelefon(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "100px",
							},
							}}
							/>
                    </TableCell>
					
					<TableCell component="th" scope="row" >
					<FormControl>
						<Label>Vrsta članstva</Label>
							<SelectVrstaClanstva  
							menuPortalTarget={document.body} 
							menuPosition={'fixed'}
							defaultValue={optionsvrstaclanstva[0]}
							options={optionsvrstaclanstva}
							components={{ Option: IconOption }}
							onChange={handleChangeVrstaClanstva}
							styles={customStyles}
						    />
					</FormControl>
					</TableCell>
					
                    <TableCell component="th" scope="row" >
					<FormControl>
						<Label>Član skupštine</Label>
					    <Checkbox
							checked={checkedclanskupstine}
							onChange={handleChangeCheckClanSkupstine}
							inputProps={{ 'aria-label': 'controlled' }}
					/>
					</FormControl>
                    </TableCell>
					
                    <TableCell component="th" scope="row" >
					<FormControl>
						<Label>Grupovođa</Label>
					    <Checkbox
							checked={checkedgrupovodja}
							onChange={handleChangeCheckGrupovodja}
							inputProps={{ 'aria-label': 'controlled' }}
					/>
					</FormControl>
                    </TableCell>
					
                    <TableCell component="th" scope="row" >
					<FormControl>
						<Label>Lovački list</Label>
					    <Checkbox
							checked={checkedlovackilist}
							onChange={handleChangeCheckLovackiList}
							inputProps={{ 'aria-label': 'controlled' }}
					/>
					</FormControl>
                    </TableCell>
											
                </TableRow>

                <TableRow>
                    <TableCell component="th" scope="row" >
						<Button onClick={postData} type='submit'>Spasi</Button>
                     </TableCell>			
                </TableRow>
				
                </TableBody>
				
              </Table>
			  
            </TableContainer>
			
        </Card>
        </Container>
    )
}